import React, { useState, useEffect } from "react";
import "./alltransaction.scss";
import Header from "../landing/navbar/Header";
import Datatable from "./DataTable/Datatable";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Calendar } from "react-multi-date-picker";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";

import moment from "moment";
import { DateRange } from "react-date-range";
import CuurentRound from "../../hooks/dataFetchers/round";
import { Dropdown } from "react-bootstrap";

const AllTransaction = ({ usdPrice, tomiPrice, btcPrice }) => {
  const project = localStorage.getItem("project");

  const tok = localStorage?.getItem("accessToken");
  const { cuurentRound } = CuurentRound();
  const [totalRound, setTotalRound] = useState([]);

  const [showfilter, setShowfilter] = useState(false);
  const handleClosefilter = () => setShowfilter(false);
  const handleShowfilter = () => {
    setShowfilter(true);
    firstTimeData();
  };

  const [showcalendar, setShowCalendar] = useState(false);
  const [alllset, setalllset] = useState("1");

  const [selectedRounds, setSelectedRounds] = useState([]);

  const [transactionApiCalled, setTransactionApiCalled] = useState(false);

  const [transactions, setTransactions] = useState([]);

  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("name");
  const [search0, setSearch0] = useState("");

  const [leaderNames, setLeaderNames] = useState([]);
  const [leaderNames2, setLeaderNames2] = useState([]);
  const [leaderFilter, setLeaderFilter] = useState("");

  const [roundFilter, setRoundFilter] = useState([]);
  const [leaderNameFilter, setLeaderNameFilter] = useState("");
  const [roleTypeFilter, setRoleTypeFilter] = useState("");
  const [saleTypeFilter, setSaleTypeFilter] = useState("");

  const [myTree, setMyTree] = useState(false);

  const [typeFilter, setTypeFilter] = useState("");
  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  const [pageCount, setPageCount] = useState(0);
  // const [tomiPrice, setTomiPrice] = useState("");

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [applyFilters, setApplyFilters] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleRoundSelection = (round) => {
    if (selectedRounds.includes(round)) {
      setSelectedRounds(
        selectedRounds.filter((selectedRound) => selectedRound !== round)
      );
    } else {
      setSelectedRounds([...selectedRounds, round]);
    }
  };

  const handleRemoveRound = (round) => {
    setRoundFilter(
      roundFilter.filter((selectedRound) => selectedRound !== round)
    );
  };

  const [selectedtypes, setSelectedtypes] = useState([]);

  const handletypeSelection = (type) => {
    if (selectedtypes.includes(type)) {
      setSelectedtypes(
        selectedtypes.filter((selectedtype) => selectedtype !== type)
      );
    } else {
      setSelectedtypes([...selectedtypes, type]);
    }
  };

  const handleRemovetype = (type) => {
    setSelectedtypes(
      selectedtypes.filter((selectedtype) => selectedtype !== type)
    );
  };

  const [selectedSaleType, setSelectedSaleType] = useState("Sale Types");
  const [checkboxes, setCheckboxes] = useState({
    ch1: false,
    ch2: false,
    ch3: false,
  });

  const handleCheckboxChange = (id) => {
    setCheckboxes((prevCheckboxes) => {
      const updatedCheckboxes = { ...prevCheckboxes };

      Object.keys(updatedCheckboxes).forEach((checkboxId) => {
        if (checkboxId !== id) {
          updatedCheckboxes[checkboxId] = false;
        }
      });

      updatedCheckboxes[id] = !prevCheckboxes[id];

      return updatedCheckboxes;
    });
  };

  const handleDropdownItemClick = (value, id) => {
    setSelectedSaleType(value);
    handleCheckboxChange(id);
  };

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleRoleSelection = (role) => {
    if (!selectedRoles.includes(role)) {
      setSelectedRoles([...selectedRoles, role]);
    }
  };
  const handleRemoveRole = (role) => {
    setSelectedRoles(
      selectedRoles.filter((selectedRole) => selectedRole !== role)
    );
  };

  useEffect(() => {
    const source = axios.CancelToken.source();

    if (usdPrice) {
      getTransactionsData(true, source);
    }
    return () => {
      source.cancel("Request cancelled because component is unmounted");
    };
  }, [
    search,
    roleTypeFilter,
    saleTypeFilter,
    leaderFilter,
    roundFilter.length,
    endDate,
    typeFilter,
    orderField,
    orderDirection,
    page,
    myTree,
    usdPrice,
  ]);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  useEffect(() => {
    getLeaderNames();
    // firstTimeData();

    // getTomiPrice();
  }, []);

  const firstTimeData = async () => {
    try {
      let b = await cuurentRound();

      if (b) {
        const result = [];
        for (let i = 1; i <= b; i++) {
          result.push(i);
        }
        setTotalRound(result);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const getLeaderNames = () => {
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-names?limit=${2000}&privateSale=${project}`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    axios(config)
      .then(function (response) {
        setLeaderNames(response?.data?.data);
        setLeaderNames2(response?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const getTransactionsData = async (filter, source) => {
    setIsLoading(true);

    setTransactions([]);
    setTransactionApiCalled(false);

    var config = {
      method: "get",
      url: `${Api_Url}/users/all-transactions?limit=10&offset=${
        page + 1
      }&privateSale=${project}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
      cancelToken: source?.token,
    };

    let dynamicQuery = config.url;
    if (search) {
      dynamicQuery += `&${searchBy}=${search}`;
    }
    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }
    // if (user?.role == "god_agent") {
    //   dynamicQuery += `&myTree=${myTree}`;
    // }
    // if (filter) {
    if (startDate && endDate) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (roundFilter?.length > 0) {
      dynamicQuery += `&round=${[roundFilter]}`;
    }
    if (saleTypeFilter) {
      dynamicQuery += `&saleType=${saleTypeFilter}`;
    }
    if (leaderFilter) {
      dynamicQuery += `&name=${encodeURIComponent(leaderFilter)}`;
    }

    if (roleTypeFilter) {
      dynamicQuery += `&leaderType=${encodeURIComponent(roleTypeFilter)}`;
    }

    config.url = dynamicQuery;
    // }

    await axios(config)
      .then(function (res) {
        setIsLoading(false);
        setCount(res?.data?.data?.count);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(true);
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          // Request was cancelled
          console.log("Request cancelled:", error.message);
          setTransactionApiCalled(true);
        } else {
          // Other errors

          setTransactionApiCalled(true);
        }
        setIsLoading(false);
      });
  };

  const makeTimeFilterFromDuration = (time) => {
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      setStartDate(date);
      setEndDate(date1);
    } else if (time == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      setStartDate(date);
      setEndDate(date1);
    } else if (time == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      setStartDate(date);
      setEndDate(date1);
    } else if (time == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      setStartDate(date);
      setEndDate(date1);
    }
  };

  const makeTimeFilterFromCalendar = (time) => {
    setalllset();
    setState(time);
    let date = null;
    let date1 = null;
    if (time) {
      let a = new Date(time[0]?.startDate);
      let b = new Date(time[0]?.endDate);

      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");

      setStartDate(date);
      setEndDate(date1);
    }
  };

  const GetSearch = (searchKey) => {
    setSearch0(searchKey);
    if (searchKey === "") {
      setLeaderFilter("");
      setLeaderNames(leaderNames2);
    } else if (searchKey?.length > 1) {
      const results = leaderNames2.filter((item) =>
        item.name?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setLeaderNames(results);
      // SearchByName(searchKey);
    }
  };
  return (
    <>
      <Header />

      <section className="all-transaction">
        <div className="theme-container">
          <div className="upper-heading">
            <h6>all Transactions</h6>
            <div className="right-content">
              <div className="option-field">
                <Dropdown className="inputdrop">
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {searchBy == "name"
                      ? "Name"
                      : searchBy == "accessCodeFilter"
                      ? "Access Code"
                      : searchBy == "walletFilter"
                      ? "Wallet Address"
                      : searchBy == "transactionFilter"
                      ? "Transaction Hash"
                      : ""}

                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <a
                      className="dropdown-item drop"
                      onClick={() => setSearchBy("name")}
                    >
                      Name
                    </a>
                    <a
                      className="dropdown-item drop"
                      onClick={() => setSearchBy("accessCodeFilter")}
                    >
                      Access Code
                    </a>
                    <a
                      className="dropdown-item drop"
                      onClick={() => setSearchBy("walletFilter")}
                    >
                      Wallet Address
                    </a>
                    <a
                      className="dropdown-item drop"
                      onClick={() => setSearchBy("transactionFilter")}
                    >
                      Transaction Hash
                    </a>
                  </Dropdown.Menu>
                </Dropdown>
                <input
                  type="text"
                  className="paddiinput"
                  placeholder="Search..."
                  onChange={(e) => {
                    if (page != 0) {
                      setPage(0);
                    }
                    setSearch(e.target.value);
                  }}
                />
                <svg className="img-fluid search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M15.7501 15.7491L12.4951 12.4941" stroke="#05BADA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="#05BADA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            
              </div>
              <button onClick={handleShowfilter} className="filter-btnnn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 7.33398V11.334L7.33333 10.0007" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.00033 11.3333L4.66699 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6663 6.66732V10.0007C14.6663 13.334 13.333 14.6673 9.99967 14.6673H5.99967C2.66634 14.6673 1.33301 13.334 1.33301 10.0007V6.00065C1.33301 2.66732 2.66634 1.33398 5.99967 1.33398H9.33301" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6663 6.66732H11.9997C9.99967 6.66732 9.33301 6.00065 9.33301 4.00065V1.33398L14.6663 6.66732Z" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                Filters
              </button>
            </div>
          </div>
          <div className="bottom-content">
            {startDate && endDate ? (
              <div className="inner-single">
                <p>Date</p>
                <div className="multi-items">
                  <h6>
                    {moment(startDate).format("DD-MMM-YYYY")} -{" "}
                    {moment(endDate).format("DD-MMM-YYYY")}
                    <svg
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setStartDate("");
                        setEndDate("");
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14282 12.8569L12.8571 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8571 12.8569L5.14282 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )}
            {roundFilter?.length > 0 ? (
              <div className="inner-single">
                <p>Rounds</p>
                <div className="multi-items">
                  {roundFilter.map((round) => {
                    return (
                      <h6 key={round}>
                        {round}{" "}
                        <svg
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setRoundFilter(
                              roundFilter.filter(
                                (selectedRound) => selectedRound !== round
                              )
                            );
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M5.14282 12.8569L12.8571 5.14258"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.8571 12.8569L5.14282 5.14258"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            )}
            {saleTypeFilter ? (
              <div className="inner-single">
                <p>Direct/Indirect Sale</p>
                <div className="multi-items">
                  <h6>
                    {saleTypeFilter == "direct"
                      ? "Direct Sales"
                      : saleTypeFilter == "indirect"
                      ? "Indirect Sales"
                      : ""}{" "}
                    <svg
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSaleTypeFilter("");
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14282 12.8569L12.8571 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8571 12.8569L5.14282 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )}

            {leaderFilter ? (
              <div className="inner-single">
                <p>By Leader Name</p>
                <div className="multi-items">
                  <h6>
                    {leaderFilter}
                    <svg
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setLeaderFilter("");
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14282 12.8569L12.8571 5.14258"
                        stroke="#fff"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8571 12.8569L5.14282 5.14258"
                        stroke="#fff"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )}
            {roleTypeFilter ? (
              <div className="inner-single">
                <p>Role</p>
                <div className="multi-items">
                  <h6>
                    {roleTypeFilter == "god_agent"
                      ? "God Leader "
                      : roleTypeFilter == "mega_agent"
                      ? "Mega Leader "
                      : roleTypeFilter == "super_agent"
                      ? "Super Leader "
                      : roleTypeFilter == "agent"
                      ? "Leader "
                      : roleTypeFilter == "mini_agent"
                      ? "Ambassador "
                      : "Role "}
                    <svg
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setRoleTypeFilter("");
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14282 12.8569L12.8571 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8571 12.8569L5.14282 5.14258"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h6>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <Datatable
            count={count}
            page={page}
            handlePageChange={handlePageChange}
            pageCount={pageCount}
            transactions={transactions}
            transactionApiCalled={transactionApiCalled}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            orderDirection={orderDirection}
            orderField={orderField}
            usdPrice={usdPrice}
            tomiPrice={tomiPrice}
            btcPrice={btcPrice}
            isLoading={isLoading}
            tok={tok}
          />
        </div>
      </section>

      <Offcanvas
        placement="end"
        className="filter-offcanvas"
        show={showfilter}
        onHide={handleClosefilter}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="uppper-area">
            <div className="custom-tab-bar">
              <a
                className={alllset == "1" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("1");

                  makeTimeFilterFromDuration("1");
                }}
              >
                1D
              </a>
              <a
                className={alllset == "seven" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("seven");

                  makeTimeFilterFromDuration("seven");
                }}
              >
                7D
              </a>
              <a
                className={alllset == "month" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("month");

                  makeTimeFilterFromDuration("month");
                }}
              >
                1M
              </a>
              <a
                className={alllset == "year" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("year");

                  makeTimeFilterFromDuration("year");
                }}
              >
                1Y
              </a>
              <a
                className={alllset == "all" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("all");

                  makeTimeFilterFromDuration("");
                }}
              >
                All
              </a>
              <a onClick={() => setShowCalendar(!showcalendar)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M17.0833 3.56V2C17.0833 1.59 16.7433 1.25 16.3333 1.25C15.9233 1.25 15.5833 1.59 15.5833 2V3.5H9.08327V2C9.08327 1.59 8.74327 1.25 8.33327 1.25C7.92327 1.25 7.58327 1.59 7.58327 2V3.56C4.88327 3.81 3.57327 5.42 3.37327 7.81C3.35327 8.1 3.59327 8.34 3.87327 8.34H20.7933C21.0833 8.34 21.3233 8.09 21.2933 7.81C21.0933 5.42 19.7833 3.81 17.0833 3.56Z"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M20.3333 9.83984H4.33328C3.78328 9.83984 3.33328 10.2898 3.33328 10.8398V16.9998C3.33328 19.9998 4.83328 21.9998 8.33328 21.9998H16.3333C19.8333 21.9998 21.3333 19.9998 21.3333 16.9998V10.8398C21.3333 10.2898 20.8833 9.83984 20.3333 9.83984ZM9.54328 18.2098C9.49328 18.2498 9.44328 18.2998 9.39328 18.3298C9.33328 18.3698 9.27328 18.3998 9.21328 18.4198C9.15328 18.4498 9.09328 18.4698 9.03328 18.4798C8.96328 18.4898 8.90328 18.4998 8.83328 18.4998C8.70328 18.4998 8.57328 18.4698 8.45328 18.4198C8.32328 18.3698 8.22328 18.2998 8.12328 18.2098C7.94328 18.0198 7.83328 17.7598 7.83328 17.4998C7.83328 17.2398 7.94328 16.9798 8.12328 16.7898C8.22328 16.6998 8.32328 16.6298 8.45328 16.5798C8.63328 16.4998 8.83328 16.4798 9.03328 16.5198C9.09328 16.5298 9.15328 16.5498 9.21328 16.5798C9.27328 16.5998 9.33328 16.6298 9.39328 16.6698C9.44328 16.7098 9.49328 16.7498 9.54328 16.7898C9.72328 16.9798 9.83328 17.2398 9.83328 17.4998C9.83328 17.7598 9.72328 18.0198 9.54328 18.2098ZM9.54328 14.7098C9.35328 14.8898 9.09328 14.9998 8.83328 14.9998C8.57328 14.9998 8.31328 14.8898 8.12328 14.7098C7.94328 14.5198 7.83328 14.2598 7.83328 13.9998C7.83328 13.7398 7.94328 13.4798 8.12328 13.2898C8.40328 13.0098 8.84328 12.9198 9.21328 13.0798C9.34328 13.1298 9.45328 13.1998 9.54328 13.2898C9.72328 13.4798 9.83328 13.7398 9.83328 13.9998C9.83328 14.2598 9.72328 14.5198 9.54328 14.7098ZM13.0433 18.2098C12.8533 18.3898 12.5933 18.4998 12.3333 18.4998C12.0733 18.4998 11.8133 18.3898 11.6233 18.2098C11.4433 18.0198 11.3333 17.7598 11.3333 17.4998C11.3333 17.2398 11.4433 16.9798 11.6233 16.7898C11.9933 16.4198 12.6733 16.4198 13.0433 16.7898C13.2233 16.9798 13.3333 17.2398 13.3333 17.4998C13.3333 17.7598 13.2233 18.0198 13.0433 18.2098ZM13.0433 14.7098C12.9933 14.7498 12.9433 14.7898 12.8933 14.8298C12.8333 14.8698 12.7733 14.8998 12.7133 14.9198C12.6533 14.9498 12.5933 14.9698 12.5333 14.9798C12.4633 14.9898 12.4033 14.9998 12.3333 14.9998C12.0733 14.9998 11.8133 14.8898 11.6233 14.7098C11.4433 14.5198 11.3333 14.2598 11.3333 13.9998C11.3333 13.7398 11.4433 13.4798 11.6233 13.2898C11.7133 13.1998 11.8233 13.1298 11.9533 13.0798C12.3233 12.9198 12.7633 13.0098 13.0433 13.2898C13.2233 13.4798 13.3333 13.7398 13.3333 13.9998C13.3333 14.2598 13.2233 14.5198 13.0433 14.7098ZM16.5433 18.2098C16.3533 18.3898 16.0933 18.4998 15.8333 18.4998C15.5733 18.4998 15.3133 18.3898 15.1233 18.2098C14.9433 18.0198 14.8333 17.7598 14.8333 17.4998C14.8333 17.2398 14.9433 16.9798 15.1233 16.7898C15.4933 16.4198 16.1733 16.4198 16.5433 16.7898C16.7233 16.9798 16.8333 17.2398 16.8333 17.4998C16.8333 17.7598 16.7233 18.0198 16.5433 18.2098ZM16.5433 14.7098C16.4933 14.7498 16.4433 14.7898 16.3933 14.8298C16.3333 14.8698 16.2733 14.8998 16.2133 14.9198C16.1533 14.9498 16.0933 14.9698 16.0333 14.9798C15.9633 14.9898 15.8933 14.9998 15.8333 14.9998C15.5733 14.9998 15.3133 14.8898 15.1233 14.7098C14.9433 14.5198 14.8333 14.2598 14.8333 13.9998C14.8333 13.7398 14.9433 13.4798 15.1233 13.2898C15.2233 13.1998 15.3233 13.1298 15.4533 13.0798C15.6333 12.9998 15.8333 12.9798 16.0333 13.0198C16.0933 13.0298 16.1533 13.0498 16.2133 13.0798C16.2733 13.0998 16.3333 13.1298 16.3933 13.1698C16.4433 13.2098 16.4933 13.2498 16.5433 13.2898C16.7233 13.4798 16.8333 13.7398 16.8333 13.9998C16.8333 14.2598 16.7233 14.5198 16.5433 14.7098Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </a>
              {/* {showcalendar && ( */}
              {showcalendar && (
                <div className="cal set-custom-calendar-div">
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => {
                      makeTimeFilterFromCalendar([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                  />
                </div>
              )}
            </div>
            <div class="dropdown round-dropdown">
              <button
                class="dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Rounds
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    // onClick={() => handleRoundSelection("All Rounds")}
                  >
                    <div className="checkboxmain">
                      <div class="content">
                        <label class="checkBox">
                          <input
                            type="checkbox"
                            id="chAll"
                            checked={roundFilter.length === totalRound.length}
                            onChange={(e) => {
                              if (e.target.checked) {
                                const allRounds = totalRound.map(
                                  (_, index) => index + 1
                                );
                                setRoundFilter(allRounds);
                              } else {
                                setRoundFilter([]);
                              }
                            }}
                          />
                          <div class="transition"></div>
                        </label>
                      </div>
                      <p className="checkboxpara">All Rounds</p>
                    </div>
                  </a>
                </li>
                {totalRound?.map((elem, index) => {
                  return (
                    <li key={index}>
                      <a
                        class="dropdown-item"
                        // onClick={() => {
                        //   setRoundFilter(index + 1);
                        // }}
                        // onClick={() => handleRoundSelection("All Rounds")}
                      >
                        <div className="checkboxmain">
                          <div class="content">
                            <label class="checkBox">
                              <input
                                type="checkbox"
                                id={`ch${index + 1}`}
                                checked={roundFilter.includes(index + 1)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    const rounds = [...roundFilter, index + 1];

                                    setRoundFilter(rounds);
                                  } else {
                                    const rounds = roundFilter.filter(
                                      (round) => round !== index + 1
                                    );

                                    setRoundFilter(rounds);
                                  }
                                }}
                              />
                              <div class="transition"></div>
                            </label>
                          </div>
                          <p className="checkboxpara">Round {index + 1}</p>
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="ifroundselect">
              {roundFilter.map((round) => (
                <h6 key={round}>
                  {round}{" "}
                  <svg
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRemoveRound(round)}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M5.14285 12.8571L12.8571 5.14282"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.8571 12.8571L5.14285 5.14282"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </h6>
              ))}
            </div>

            {/* <div class="dropdown round-dropdown">
              <button
                class="dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Sale Type
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                >
                  <path
                    d="M8.30454 0H4.29972H0.693464C0.0763497 0 -0.232207 0.910697 0.204915 1.44455L3.53476 5.51129C4.06831 6.1629 4.93612 6.1629 5.46967 5.51129L6.73604 3.96467L8.79952 1.44455C9.23021 0.910697 8.92165 0 8.30454 0Z"
                    fill="black"
                  />
                </svg>
              </button>
              <ul class="dropdown-menu">
 
                <li>
                  <a class="dropdown-item">
                    <div className="checkboxmain">
                      <div class="content">
                        <label class="checkBox">
                          <input
                            type="checkbox"
                            id="chDirectSale"
                            checked={saleTypeFilter == "direct"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSaleTypeFilter("direct");
                              } else {
                                setSaleTypeFilter(
                                  saleTypeFilter.filter(
                                    (type) => type !== "direct"
                                  )
                                );
                              }
                            }}
                          />
                          <div class="transition"></div>
                        </label>
                      </div>
                      <p className="checkboxpara">Direct Sale</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item">
                    <div className="checkboxmain">
                      <div class="content">
                        <label class="checkBox">
                          <input
                            type="checkbox"
                            id="chIndirectSale"
                            checked={saleTypeFilter == "indirect"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSaleTypeFilter("indirect");
                              } else {
                                setSaleTypeFilter(
                                  saleTypeFilter.filter(
                                    (type) => type !== "indirect"
                                  )
                                );
                              }
                            }}
                          />
                          <div class="transition"></div>
                        </label>
                      </div>
                      <p className="checkboxpara">Indirect Sale</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div className="ifroundselect">
              {saleTypeFilter.map((type) => (
              {saleTypeFilter != "" ? (
                <h6>
                  {saleTypeFilter == "direct"
                    ? "Direct Sales"
                    : saleTypeFilter == "indirect"
                    ? "Indirect Sales"
                    : ""}{" "}
                  <svg
                    style={{ cursor: "pointer" }}
                    onClick={() => setSaleTypeFilter("")}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M5.14285 12.8571L12.8571 5.14282"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.8571 12.8571L5.14285 5.14282"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </h6>
              ) : (
                ""
              )}
            </div> */}

            {/* <div className="dropdown round-dropdown">
                            <button
                                className="dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {selectedSaleType}
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
                                    <path d="M8.30454 0H4.29972H0.693464C0.0763497 0 -0.232207 0.910697 0.204915 1.44455L3.53476 5.51129C4.06831 6.1629 4.93612 6.1629 5.46967 5.51129L6.73604 3.96467L8.79952 1.44455C9.23021 0.910697 8.92165 0 8.30454 0Z" fill="black" />
                                </svg>
                            </button>
                            <ul className="dropdown-menu">
                                <li>
                                    <a
                                        className="dropdown-item"
                                        onClick={() => handleDropdownItemClick('All Sale Types', 'ch1')}
                                    >
                                        <div className="checkboxmain">
                                            <div className="content">
                                                <label className="checkBox">
                                                    <input
                                                        type="checkbox"
                                                        id="ch1"
                                                        checked={checkboxes.ch1}
                                                        onChange={() => handleCheckboxChange('ch1')}
                                                    />
                                                    <div className="transition"></div>
                                                </label>
                                            </div>
                                            <p className="checkboxpara">All Sale Types</p>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="dropdown-item"
                                        onClick={() => handleDropdownItemClick('Direct Sale', 'ch2')}
                                    >
                                        <div className="checkboxmain">
                                            <div className="content">
                                                <label className="checkBox">
                                                    <input
                                                        type="checkbox"
                                                        id="ch2"
                                                        checked={checkboxes.ch2}
                                                        onChange={() => handleCheckboxChange('ch2')}
                                                    />
                                                    <div className="transition"></div>
                                                </label>
                                            </div>
                                            <p className="checkboxpara">Direct Sale</p>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="dropdown-item"
                                        onClick={() => handleDropdownItemClick('Indirect Sale', 'ch3')}
                                    >
                                        <div className="checkboxmain">
                                            <div className="content">
                                                <label className="checkBox">
                                                    <input
                                                        type="checkbox"
                                                        id="ch3"
                                                        checked={checkboxes.ch3}
                                                        onChange={() => handleCheckboxChange('ch3')}
                                                    />
                                                    <div className="transition"></div>
                                                </label>
                                            </div>
                                            <p className="checkboxpara">Indirect Sale</p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div> */}
            {user?.role !== "mini_agent" && user?.role !== "agent" && (
              <>
                <div>
                  <div class="dropdown dropdownbysearch">
                    <button
                      class="dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      By Leader Name
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="8"
                        viewBox="0 0 15 8"
                        fill="none"
                      >
                        <path
                          d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                          fill="#fff"
                        />
                        <path
                          d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
                          fill="#fff"
                        />
                      </svg>
                    </button>
                    <ul class="dropdown-menu gycytctdtrctrc">
                      <div className="custom-option-field drop-in-search-sticky">
                        <input
                          value={search0}
                          type="search"
                          placeholder="Search"
                          onChange={(e) => GetSearch(e.target.value)}
                        />

                        <img
                          style={{ cursor: "pointer" }}
                          src="\assets\transaction\search-icon.svg"
                          alt="img"
                          className="img-fluid search-icon"
                        />
                      </div>

                      {leaderNames?.length > 0
                        ? leaderNames?.map((item) => {
                            return (
                              <>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                      setLeaderFilter(item?.name);
                                      setSearch0(item?.name);
                                    }}
                                  >
                                    {item?.name}
                                  </a>
                                </li>
                              </>
                            );
                          })
                        : null}
                    </ul>
                  </div>
                  <div className="ifroundselect">
                    {leaderFilter != "" ? (
                      <h6>
                        {leaderFilter}
                        <svg
                          style={{ cursor: "pointer" }}
                          onClick={() => setLeaderFilter("")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M5.14285 12.8571L12.8571 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.8571 12.8571L5.14285 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div>
                  <div className="dropdown round-dropdown role-dropdown">
                    <button
                      className="dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {roleTypeFilter == "god_agent"
                        ? "God Leader "
                        : roleTypeFilter == "mega_agent"
                        ? "Mega Leader "
                        : roleTypeFilter == "super_agent"
                        ? "Super Leader "
                        : roleTypeFilter == "agent"
                        ? "Leader "
                        : roleTypeFilter == "mini_agent"
                        ? "Ambassador "
                        : "Role "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="8"
                        viewBox="0 0 15 8"
                        fill="none"
                      >
                        <path
                          d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                          fill="#fff"
                        />
                        <path
                          d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
                          fill="#fff"
                        />
                      </svg>
                    </button>

                    {user?.role == "admin" ? (
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            onClick={() => setRoleTypeFilter("")}
                            class="dropdown-item"
                            href="#"
                          >
                            All Leaders
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("god_agent");
                            }}
                          >
                            God
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mega_agent");
                            }}
                          >
                            Mega
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("super_agent");
                            }}
                          >
                            Super
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("agent");
                            }}
                          >
                            Leader
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mini_agent");
                            }}
                          >
                            Ambassador
                          </a>
                        </li>
                      </ul>
                    ) : user?.role == "god_agent" ? (
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            onClick={() => setRoleTypeFilter("")}
                            class="dropdown-item"
                            href="#"
                          >
                            All Leaders
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mega_agent");
                            }}
                          >
                            Mega
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("super_agent");
                            }}
                          >
                            Super
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("agent");
                            }}
                          >
                            Leader
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mini_agent");
                            }}
                          >
                            Ambassador
                          </a>
                        </li>
                      </ul>
                    ) : user?.role == "mega_agent" ? (
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            onClick={() => setRoleTypeFilter("")}
                            class="dropdown-item"
                            href="#"
                          >
                            All Leaders
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("super_agent");
                            }}
                          >
                            Super
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("agent");
                            }}
                          >
                            Leader
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mini_agent");
                            }}
                          >
                            Ambassador
                          </a>
                        </li>
                      </ul>
                    ) : user?.role == "super_agent" ? (
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            onClick={() => setRoleTypeFilter("")}
                            class="dropdown-item"
                            href="#"
                          >
                            All Leaders
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("agent");
                            }}
                          >
                            Leader
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={() => {
                              setRoleTypeFilter("mini_agent");
                            }}
                          >
                            Ambassador
                          </a>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}

                    {/* <ul className="dropdown-menu">
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setRoleTypeFilter("god_agent");
                          }}
                        >
                          God
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setRoleTypeFilter("mega_agent");
                          }}
                        >
                          Mega
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setRoleTypeFilter("super_agent");
                          }}
                        >
                          Super
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setRoleTypeFilter("agent");
                          }}
                        >
                          Leader
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            setRoleTypeFilter("mini_agent");
                          }}
                        >
                          Ambassador
                        </a>
                      </li>
                    </ul> */}
                  </div>
                  <div className="ifroundselect">
                    {roleTypeFilter != "" ? (
                      <h6>
                        {roleTypeFilter == "god_agent"
                          ? "God Leader "
                          : roleTypeFilter == "mega_agent"
                          ? "Mega Leader "
                          : roleTypeFilter == "super_agent"
                          ? "Super Leader "
                          : roleTypeFilter == "agent"
                          ? "Leader "
                          : roleTypeFilter == "mini_agent"
                          ? "Ambassador "
                          : ""}
                        <svg
                          style={{ cursor: "pointer" }}
                          onClick={() => setRoleTypeFilter("")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M5.14285 12.8571L12.8571 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.8571 12.8571L5.14285 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    ) : (
                      ""
                    )}
                  </div>
                </div>{" "}
              </>
            )}
          </div>
          <div className="bottom-btns">
            <button
              className="btn-clearall"
              onClick={() => {
                setStartDate("");
                setEndDate("");
                setSearch("");
                setRoundFilter([]);
                setLeaderNameFilter("");
                setLeaderFilter("");
                setRoleTypeFilter("");
                setSaleTypeFilter("");

                // getTransactionsData(false);
              }}
            >
              Clear all
            </button>
            <button
              className="btn-applyy"
              onClick={() => {
                getTransactionsData(true);
                handleClosefilter();
              }}
            >
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AllTransaction;
